import type { ComponentPropsWithoutRef } from 'react';
import styles from './SearchInput.module.css';

interface SearchInputProps extends Omit<ComponentPropsWithoutRef<'input'>, 'type' | 'className'> {
  readonly label: string;
}

export function SearchInput({ label, id, ...props }: SearchInputProps) {
  return (
    <div className={styles.searchBox}>
      <label htmlFor={id} className="visually-hidden">
        {label}
      </label>
      <input type="text" id={id} className={styles.input} {...props} />
    </div>
  );
}
